export type Guard<TData> =
  | { data: null; error: Error }
  | { data: Awaited<TData>; error: null };

export default async function guard<TData>(
  catchable: PromiseLike<TData>,
): Promise<Guard<TData>> {
  try {
    return {
      data: await catchable,
      error: null,
    };
  } catch (error) {
    return {
      data: null,
      error: error instanceof Error ? error : new Error(String(error)),
    };
  }
}
